import { render, staticRenderFns } from "./DashboardRemessas.vue?vue&type=template&id=73350da7"
import script from "./DashboardRemessas.vue?vue&type=script&lang=js"
export * from "./DashboardRemessas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports